<template>
  <div style="display: flex; align-items: flex-start">
    <el-card style="width: 100%">
      <div
        slot="header"
        class="clearfix"
      >
        <span>Bizonylat előtagok</span>
        <el-button
          v-can="'receiptsetting.update'"
          style="float: right; margin-top: -5px;"
          type="primary"
          size="small"
          :loading="buttonLoading"
          @click="save"
        >
          Mentés
        </el-button>
      </div>
      <receipt-setting-list
        ref="prefixes"
      />
    </el-card>
  </div>
</template>

<script>
  import ReceiptSettingList from '../components/receipts/Prefixes';
  export default {
    components: {
      ReceiptSettingList,
    },
    data() {
      return {
        buttonLoading: false,
      };
    },
    methods: {
      async save() {
        this.buttonLoading = true;
        await this.$store.dispatch('receiptSetting/update', { prefixes: this.$refs['prefixes'].receiptSettings });
        await this.$store.dispatch('receiptSetting/fetchAll');
        this.buttonLoading = false;
      },
    },
  };
</script>
